// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceTemplate_invoiceTemplate__FGrTM {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 12px;
  background-color: var(--white);
  cursor: pointer;
  transition: all 0.4s;
  height: 100%;
}
.InvoiceTemplate_invoiceTemplate__FGrTM.InvoiceTemplate_selected__sAtIo {
  border: 1px solid var(--brand);
  background-color: #F2F6F8;
}
.InvoiceTemplate_invoiceTemplate__FGrTM.InvoiceTemplate_selected__sAtIo .InvoiceTemplate_invoiceTemplateText__UoQRk {
  border-top: 1px solid var(--brand);
}
.InvoiceTemplate_invoiceTemplate__FGrTM.InvoiceTemplate_selected__sAtIo .InvoiceTemplate_invoiceTemplateText__UoQRk .InvoiceTemplate_invoiceTemplateTextHeading__eQ15f {
  color: var(--brand);
}
.InvoiceTemplate_invoiceTemplate__FGrTM:hover .InvoiceTemplate_invoiceTemplateImg__\\+6bYz .InvoiceTemplate_invoiceTemplateBtn__3-5hm {
  scale: 1;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateImg__\\+6bYz {
  position: relative;
  padding: 12px;
  padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateImg__\\+6bYz img {
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: top;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateImg__\\+6bYz .InvoiceTemplate_invoiceTemplateBtn__3-5hm {
  position: absolute;
  top: 8px;
  right: 8px;
  scale: 0;
  transition: all 0.4s;
  padding: 8px !important;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateText__UoQRk {
  border-top: 1px solid var(--border);
  padding: 12px;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateText__UoQRk .InvoiceTemplate_invoiceTemplateTextHeading__eQ15f {
  font: var(--body-font-three);
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--Brand);
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateText__UoQRk .InvoiceTemplate_invoiceTemplateTextHeading__eQ15f img {
  width: 20px;
  height: 20px;
  opacity: 0;
  transition: all 0.4s;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateText__UoQRk .InvoiceTemplate_invoiceTemplateTextHeading__eQ15f img.InvoiceTemplate_ImgSelected__qeMu- {
  opacity: 1;
}
.InvoiceTemplate_invoiceTemplate__FGrTM .InvoiceTemplate_invoiceTemplateText__UoQRk .InvoiceTemplate_invoiceTemplateTextSubHeading__Av5wP {
  font: var(--body-font-four);
  color: var(--primary-Text);
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/InvoiceTemplate/InvoiceTemplate.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,+BAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AACJ;AACI;EACI,8BAAA;EACA,yBAAA;AACR;AACQ;EACI,kCAAA;AACZ;AACY;EACI,mBAAA;AAChB;AAMY;EACI,QAAA;AAJhB;AASI;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AASQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAPZ;AAUQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;EACA,oBAAA;EACA,uBAAA;AARZ;AAYI;EACI,mCAAA;EACA,aAAA;AAVR;AAYQ;EACI,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,mBAAA;AAXZ;AAaY;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AAXhB;AAagB;EACI,UAAA;AAXpB;AAgBQ;EACI,2BAAA;EACA,0BAAA;EACA,eAAA;AAdZ","sourcesContent":[".invoiceTemplate {\r\n    width: 100%;\r\n    border: 1px solid var(--border);\r\n    border-radius: 12px;\r\n    background-color: var(--white);\r\n    cursor: pointer;\r\n    transition: all 0.4s;\r\n    height: 100%;\r\n\r\n    &.selected {\r\n        border: 1px solid var(--brand);\r\n        background-color: #F2F6F8;\r\n\r\n        .invoiceTemplateText {\r\n            border-top: 1px solid var(--brand);\r\n\r\n            .invoiceTemplateTextHeading {\r\n                color: var(--brand);\r\n            }\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .invoiceTemplateImg {\r\n            .invoiceTemplateBtn {\r\n                scale: 1;\r\n            }\r\n        }\r\n    }\r\n\r\n    .invoiceTemplateImg {\r\n        position: relative;\r\n        padding: 12px;\r\n        padding-bottom: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        img {\r\n            width: 100%;\r\n            height: auto;\r\n            object-fit: cover;\r\n            object-position: top;\r\n        }\r\n\r\n        .invoiceTemplateBtn {\r\n            position: absolute;\r\n            top: 8px;\r\n            right: 8px;\r\n            scale: 0;\r\n            transition: all 0.4s;\r\n            padding: 8px !important;\r\n        }\r\n    }\r\n\r\n    .invoiceTemplateText {\r\n        border-top: 1px solid var(--border);\r\n        padding: 12px;\r\n\r\n        .invoiceTemplateTextHeading {\r\n            font: var(--body-font-three);\r\n            font-weight: 600;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n\r\n            color: var(--Brand);\r\n\r\n            img {\r\n                width: 20px;\r\n                height: 20px;\r\n                opacity: 0;\r\n                transition: all 0.4s;\r\n\r\n                &.ImgSelected {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n\r\n        .invoiceTemplateTextSubHeading {\r\n            font: var(--body-font-four);\r\n            color: var(--primary-Text);\r\n            margin-top: 8px;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoiceTemplate": `InvoiceTemplate_invoiceTemplate__FGrTM`,
	"selected": `InvoiceTemplate_selected__sAtIo`,
	"invoiceTemplateText": `InvoiceTemplate_invoiceTemplateText__UoQRk`,
	"invoiceTemplateTextHeading": `InvoiceTemplate_invoiceTemplateTextHeading__eQ15f`,
	"invoiceTemplateImg": `InvoiceTemplate_invoiceTemplateImg__+6bYz`,
	"invoiceTemplateBtn": `InvoiceTemplate_invoiceTemplateBtn__3-5hm`,
	"ImgSelected": `InvoiceTemplate_ImgSelected__qeMu-`,
	"invoiceTemplateTextSubHeading": `InvoiceTemplate_invoiceTemplateTextSubHeading__Av5wP`
};
export default ___CSS_LOADER_EXPORT___;
